/**
 * 5897 — Lotes em risco de esgotar: lotes abertos com quantidade definida
 * (no ingresso ou no setor), pela chance de esgotar em 7 dias.
 */
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { PrevisaoLote } from '../../../types/previsoes'
import { BD, PageSubtitle, PageTitle, Table } from '../styles'
import { BarraReferencia, CartaoTabela, ComPainel, Entenda, Rolagem, Selo, comRef, fmtInt, pct, useReferencia } from './comum'

const MAX_LINHAS = 200

export const TabelaLotes: FC<{ lotes: PrevisaoLote[]; comEvento?: boolean }> = ({ lotes, comEvento = true }) => {
  const navigate = useNavigate()
  const [ref] = useReferencia()
  return (
    <Rolagem>
      <Table>
        <thead>
          <tr>
            {comEvento && <th>Evento</th>}
            <th>Ingresso / setor · lote</th>
            <th className="n">Vendidos / qtd</th>
            <th className="n">Ritmo/dia</th>
            <th className="n">D-</th>
            <th className="n">Esgota em 7 dias</th>
            <th className="n">Antes do evento</th>
            <th className="n">Janela provável</th>
            <th>Leitura</th>
          </tr>
        </thead>
        <tbody>
          {lotes.map((l, i) => (
            <tr
              // ingressos diferentes podem ter o mesmo nome no mesmo lote
              key={`${l.evento_id}|${l.unidade}|${l.item}|${l.lote}|${i}`}
              onClick={comEvento ? () => navigate(comRef(`/interno/previsoes/evento/${l.evento_id}`, ref)) : undefined}
              style={comEvento ? undefined : { cursor: 'default' }}
            >
              {comEvento && <td style={{ fontWeight: 500, maxWidth: 300 }}>{l.evento}</td>}
              <td>
                {l.item}
                <small>
                  {l.lote} · {l.unidade === 'setor' ? 'estoque do setor' : 'estoque do ingresso'}
                </small>
              </td>
              <td className="n">
                {fmtInt(l.vend)} / {fmtInt(l.qtd)}
              </td>
              <td className="n">{String(l.ritmo).replace('.', ',')}</td>
              <td className="n">{l.dias}</td>
              <td className="n">
                <strong>{pct(l.p7)}</strong>
              </td>
              <td className="n">
                {l.pev === null ? <span style={{ color: BD.grayText }}>não validado</span> : pct(l.pev)}
              </td>
              <td className="n">{l.janela ? `${l.janela} dias` : '—'}</td>
              <td>
                <Selo
                  tom={
                    l.leitura.indexOf('lote acabando') === 0
                      ? 'ruim'
                      : l.leitura.indexOf('sem evid') === 0
                      ? 'bom'
                      : 'atencao'
                  }
                >
                  {l.leitura}
                </Selo>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Rolagem>
  )
}

export const PrevisoesLotes: FC = () => (
  <ComPainel>
    {(painel, referencias) => (
      <>
        <PageTitle>Lotes em risco de esgotar</PageTitle>
        <PageSubtitle>
          Lotes abertos com quantidade definida (no ingresso ou no setor), ordenados pela chance de esgotar em 7 dias.
          {painel.lotes.length > MAX_LINHAS && ` Mostrando os ${MAX_LINHAS} primeiros de ${fmtInt(painel.lotes.length)}.`}
        </PageSubtitle>
        <BarraReferencia painel={painel} referencias={referencias} />
        <CartaoTabela>
          {painel.lotes.length > 0 ? (
            <TabelaLotes lotes={painel.lotes.slice(0, MAX_LINHAS)} />
          ) : (
            <p style={{ padding: 20, color: BD.grayText }}>Nenhum lote aberto com quantidade definida.</p>
          )}
        </CartaoTabela>
        <Entenda
          paragrafos={[
            '"Esgota em 7 dias" foi validado para ingresso e para estoque compartilhado de setor. "Antes do evento" só para ingresso; para setor ainda falta histórico.',
            'A janela provável acerta ~83% das vezes; quando o fim está a até 3 dias, ela tem ~5 dias de largura.',
            'Prever o esgotamento não é recomendar virada: 68% das viradas são decisão do produtor.',
          ]}
        />
      </>
    )}
  </ComPainel>
)
